import { gql } from '@apollo/client';

export const CONVERSATION_FIELDS_FRAGMENT = gql`
  fragment ConversationFields on Conversation {
    objectId: id
    createdAt
    updatedAt
    lastMessageObjectId
    subject
    customerChannel
    simplrChannel
    lastMessageBody
    conversationType
    status
    lastMessageDirection
    zendeskTicketId
    zendeskDomain
    simplrTicketNumber
    smbName
    conversationSid
    deskTicketId
    deskDomain
    Comments
    paymentStatus
    platformAssigneeName
    autoResponse
    communicationType
    platformTicketId
    platformDomain
    orderingSystem
    sessionToken
    comments
    platformStatus
    lastAutoRoutingAlgorithm
    platformAssigneeType
    include
    invalidDamien
    brand
    chatStatus
    department
    externalOperatorDecision
    responseCompleteness
    firstMessageObjectId
    associatedOrderNumber
    category
    reviewStatus
    platformAuthorId
    chatResponseState
    language
    isOpen
    onHold
    hasSentSurvey
    isTestTicket
    useMasterKey
    escalatedForReview
    unreadCount
    shopifyOrderNumber
    platformAssigneeId
    rating
    numValidationsRequired
    conversationUpdatedAt
    firstMessageArrivedAt
    closedAt
    lastInboundMessageAt
    originalCreatedAt
    escalatedAt
    conversationOpenedAt
    firstExpertResponseSentAt
    firstReadyForNominationAt
    ticketReviewedAt
    lastStatusChangedAt
    lastSyncedAt
    chatDelayedAt
    simplrAccountId
    simplrAccountPtr {
      objectId: id
      accountStatus
      minimumExpertRank
      escalateEmail
    }
    closedById
    closedByExpertId
    simplrExpertId
    simplrExpertPtr {
      objectId: id
      createdAt
      updatedAt
      isAdmin
      isSpecialist
      isActive
      status
      firstName
      lastName
      email
      phone
      isDeleted
      simplrAccountId
      userId
      avatarName
      userPhoneCountryCode
      userPhone
      isExpert
      expertType
      rank
      lastNominatedAt
      availability
      blacklistedBusinesses
      numChatNominated
      numEmailNominated
      numNonChatUnansweredAssigned
      numChatUnansweredAssigned
      chatDisabled
      blacklistedBusinessIdsForChat
      lastActivityAt
      numChatActiveAssigned
      expertClass
      lastEmailNominatedAt
      lastEmailAssignedAt
      lastChatNominatedAt
      lastChatAssignedAt
      lastActiveChatAt
      chatModeSince
      chatMode
      endChatModeAt
      expertReviewPopupAcknowledged
      availabilitySwitchLockExpiresAt
      expertToggleLockConfirmation
      numReviewedTickets
      locationCountry
    }
    reviewExpertId
    reviewExpertPtr {
      objectId: id
    }
    closedByUserId
    lastMessageId
    lastMessagePtr {
      objectId: id
      source
      couponCodePtr {
        objectId: id
        createdAt
        updatedAt
        code
        brandName
        sentCount
        maxSends
        isActive
        hasSendsLeft
        generatedAt
        expiresAt
        couponCodeTypeId
      }
    }
    customerId
    customerPtr {
      objectId: id
      createdAt
      updatedAt
      customerPhone
      customerEmail
      customerFirstName
      customerLastName
      channel
      phoneNumber
      customerExternalId
      simplrAccountId
    }
    channelId
    decisionFlowStatusId
    transcriptId
    roomId
    transcriptUrl
    platformTicketType
    combinedTags
    pendingPartnerReachOut
    qualityRating
    mlData
    platformTags
    moreTicketInfo
    extraTicketInfo
    tagHistory
  }
`;
